// Used to define the top area (container) of a view.
// i.e. the blue section containing (e.g.) tabs, breadcrumbs, pill buttons UI.

import { styled } from '@mui/material/styles';
import { Blue } from '../../themes/blue/colorPalette';

const PageHeader = styled('div')({
    background: 'linear-gradient(160deg, #2680C2 60%, rgba(64,152,215,1) 100%)',
    paddingTop: 4,
    '& .MuiTypography-h1': {
        padding: 16,
        paddingLeft: 0,
        color: 'white',
        fontSize: '20px',
        lineHeight: '23px',
        display: 'inline-block'
    },
    '& .MuiTypography-subtitle1': {
        padding: 16,
        paddingLeft: 0,
        color: Blue[8],
        fontSize: '15px',
        lineHeight: '23px',
        fontWeight: 400,
        display: 'inline-block'
    }
});

export default PageHeader;
